import { Box, } from '@mui/material';
import React from 'react';
import { Helmet, } from 'react-helmet';
import { useIntl, } from 'react-intl';
import ScrollToTop from '@/ScrollToTop';
import Block1 from './component/Block1';
import Block2 from './component/Block2';

const Contact = () => {
  const intl = useIntl();

  // meta tag文案
  const pageTitle = intl.formatMessage({ id: 'contact.page.title', });
  const ogTagTitle = intl.formatMessage({ id: 'contact.ogtag.title', });
  const ogTagDescription = intl.formatMessage({ id: 'contact.ogtag.description', });

  return (
    <Box>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={ogTagDescription}
        ></meta>
        <meta
          property="og:title"
          content={ogTagTitle}
        />
        <meta
          property="og:description"
          content={ogTagDescription}
        />
      </Helmet>
      <ScrollToTop />
      <Block1 />
      <Block2 />
    </Box>
  );
};

export default React.memo(Contact);